import { IIqbhBookFormConfig } from "libraries/interfaces/i-iaqoboh-reservation-form-config";
import { EHosts } from "libraries/enums/EHosts";


export const RESERVATION_FORM: IIqbhBookFormConfig = {
    emergencyContactForm: {
        labelArray: [
            {
                languageCode: "fr",
                value: "Contact du client"
            },
            {
                languageCode: "en",
                value: "Guest contact"
            }
        ],
        showCondition: {
            isAlways: true,
            conditionArray: [
                {
                    host: EHosts.EXPEDIA
                }
            ]
        },
        fieldArray: [
            {
                code: "countryPrefix",
                isDisplayed: true,
                defaultValue: "GB",
                type: "list",
                labelArray: [
                    {
                        languageCode: "fr",
                        value: "Préfix"
                    }
                ]
            },
            {
                code: "number",
                isDisplayed: true,
                type: "phoneNumber",
                labelArray: [
                    {
                        languageCode: "fr",
                        value: "Téléphone"
                    }
                ]
            },
            {
                code: "email",
                isDisplayed: false,
                type: "email",
                labelArray: [
                    {
                        languageCode: "fr",
                        value: "e-mail"
                    }
                ]
            },
            {
                code: "portable",
                isDisplayed: true,
                type: "phoneNumber",
                labelArray: [
                    {
                        languageCode: "fr",
                        value: "Téléphone portable"
                    }
                ]
            }
        ]
    },
    servicesForm: {
        labelArray: [
            {
                languageCode: "fr",
                value: "Demandes sp\u00e9ciales"
            },
            {
                languageCode: "en",
                value: "Special demands"
            }
        ],
        showCondition: {
            isAlways: false,
            conditionArray: [
                {
                    host: EHosts.BONOTEL,
                }
            ]
        },
        checkboxArray: [
            {
                labelArray: [
                    {
                        languageCode: "fr",
                        value: "Demande de transfert a\u00e9roport"
                    },
                    {
                        languageCode: "en",
                        value: "Note en"
                    }
                ],
                value: "transfert a\u00e9roport"
            }
        ]
    }
};
